import * as angular from "angular";
import { v4 as uuid } from "uuid";
import restoreFocusWhen from "../../../behaviors/restore-focus-when";
import tabListNavigation from "../../../behaviors/tab-list-navigation";
import template from "./tabbed-modal-tabs.html";
import "./tabbed-modal-tabs.less";
import type { ModalTabHandle } from "./modalTabHandle";

export interface TabbedModalTabsController {
	items: ReadonlyArray<ModalTabHandle>;
	selected?: string;
	label?: string;
	onChange?: (locals: { item: ModalTabHandle }) => void;
}

// AngularJS owns these merged binding properties; keeping them type-only preserves pre-assigned values.
// eslint-disable-next-line no-redeclare
export class TabbedModalTabsController {
	public isOpen = false;
	public readonly listId = `tabbed-modal-tabs-${uuid()}`;

	public $onInit(): void {
		this.label = this.label || "Sections";
	}

	public get selectedName(): string {
		return this.items.find(item => item.isSelectable && item.isSame(this.selected))?.name
			?? this.label
			?? "";
	}

	public isSelected(item: ModalTabHandle): boolean {
		return item.isSelectable && item.isSame(this.selected);
	}

	public select(item: ModalTabHandle): void {
		if(!item.isSelectable) {
			return;
		}

		this.isOpen = false;
		this.onChange?.({ item });
	}

	public toggle(): void {
		this.isOpen = !this.isOpen;
	}
}

export default angular
	.module("vesl.components.tabbed-modal.tabs", [restoreFocusWhen, tabListNavigation])
	.component("tabbedModalTabs", {
		template,
		controller: TabbedModalTabsController,
		bindings: {
			items: "<",
			selected: "<",
			label: "@",
			onChange: "&"
		}
	})
	.name;
